"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var lodash_1 = require("lodash");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var utils_1 = require("./utils");
// names inside this class and discovery logic respect BIP32 standard
var Xpub = /** @class */ (function () {
    function Xpub(_a) {
        var storage = _a.storage, explorer = _a.explorer, crypto = _a.crypto, xpub = _a.xpub, derivationMode = _a.derivationMode;
        // https://github.com/bitcoinjs/bitcoinjs-lib/blob/27a840aac4a12338f1e40c54f3759bbd7a559944/src/bufferutils.js#L24
        // only works with number so we need to be sure to pass correct numbers
        this.OUTPUT_VALUE_MAX = Number.MAX_SAFE_INTEGER;
        this.GAP = 20;
        // need to be bigger than the number of tx from the same address that can be in the same block
        this.txsSyncArraySize = 1000;
        this.storage = storage;
        this.explorer = explorer;
        this.crypto = crypto;
        this.xpub = xpub;
        this.derivationMode = derivationMode;
        this.freshAddress = "";
        this.freshAddressIndex = 0;
    }
    Xpub.prototype.syncAddress = function (account, index) {
        return __awaiter(this, void 0, void 0, function () {
            var address, hasPendings, lastTx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.crypto.getAddress(this.derivationMode, this.xpub, account, index)];
                    case 1:
                        address = _a.sent();
                        this.storage.addAddress("".concat(this.crypto.network.name, "-").concat(this.derivationMode, "-").concat(this.xpub, "-").concat(account, "-").concat(index), address);
                        // TODO handle eventual reorg case using lastBlock
                        // TODO perf: bad : looping in the tx array
                        return [4 /*yield*/, this.checkAddressReorg(account, index)];
                    case 2:
                        // TODO handle eventual reorg case using lastBlock
                        // TODO perf: bad : looping in the tx array
                        _a.sent();
                        hasPendings = !!this.storage.getLastTx({
                            confirmed: false,
                            account: account,
                            index: index
                        });
                        if (hasPendings) {
                            this.storage.removePendingTxs({ account: account, index: index });
                        }
                        return [4 /*yield*/, this.fetchHydrateAndStoreNewTxs(address, account, index)];
                    case 3:
                        _a.sent();
                        lastTx = this.storage.getLastTx({
                            account: account,
                            index: index
                        });
                        if (account === 0 && lastTx) {
                            this.freshAddressIndex = Math.max(this.freshAddressIndex, index + 1);
                        }
                        return [2 /*return*/, !!lastTx];
                }
            });
        });
    };
    Xpub.prototype.checkAddressesBlock = function (account, index) {
        return __awaiter(this, void 0, void 0, function () {
            var addressesResults;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all((0, lodash_1.range)(this.GAP).map(function (_, key) { return _this.syncAddress(account, index + key); }))];
                    case 1:
                        addressesResults = _a.sent();
                        return [2 /*return*/, (0, lodash_1.some)(addressesResults, function (lastTx) { return !!lastTx; })];
                }
            });
        });
    };
    Xpub.prototype.syncAccount = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var index;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index = 0;
                        _a.label = 1;
                    case 1: return [4 /*yield*/, this.checkAddressesBlock(account, index)];
                    case 2:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        index += this.GAP;
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, index];
                }
            });
        });
    };
    // TODO : test fail case + incremental
    Xpub.prototype.sync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var account, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.freshAddressIndex = 0;
                        account = 0;
                        _c.label = 1;
                    case 1:
                        _a = account < 2;
                        if (!_a) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.syncAccount(account)];
                    case 2:
                        _a = (_c.sent());
                        _c.label = 3;
                    case 3:
                        if (!_a) return [3 /*break*/, 4];
                        // account=0 for receive address; account=1 for change address. No need to handle account>1
                        account += 1;
                        return [3 /*break*/, 1];
                    case 4:
                        _b = this;
                        return [4 /*yield*/, this.crypto.getAddress(this.derivationMode, this.xpub, 0, this.freshAddressIndex)];
                    case 5:
                        _b.freshAddress = _c.sent();
                        return [2 /*return*/, account];
                }
            });
        });
    };
    Xpub.prototype.getXpubBalance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var addresses;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getXpubAddresses()];
                    case 1:
                        addresses = _a.sent();
                        return [2 /*return*/, this.getAddressesBalance(addresses)];
                }
            });
        });
    };
    Xpub.prototype.getAccountBalance = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var addresses;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccountAddresses(account)];
                    case 1:
                        addresses = _a.sent();
                        return [2 /*return*/, this.getAddressesBalance(addresses)];
                }
            });
        });
    };
    Xpub.prototype.getAddressBalance = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var unspentUtxos;
            return __generator(this, function (_a) {
                unspentUtxos = this.storage.getAddressUnspentUtxos(address);
                return [2 /*return*/, unspentUtxos.reduce(function (total, _a) {
                        var value = _a.value;
                        return total.plus(value);
                    }, new bignumber_js_1["default"](0))];
            });
        });
    };
    Xpub.prototype.getXpubAddresses = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.storage.getUniquesAddresses({})];
            });
        });
    };
    Xpub.prototype.getAccountAddresses = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.storage.getUniquesAddresses({ account: account })];
            });
        });
    };
    Xpub.prototype.getNewAddress = function (account, gap) {
        return __awaiter(this, void 0, void 0, function () {
            var accountAddresses, lastIndex, index, address;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getAccountAddresses(account)];
                    case 1:
                        accountAddresses = _b.sent();
                        lastIndex = ((0, lodash_1.maxBy)(accountAddresses, "index") || { index: -1 }).index;
                        if (lastIndex === -1) {
                            index = 0;
                        }
                        else {
                            index = lastIndex + gap;
                        }
                        _a = {};
                        return [4 /*yield*/, this.crypto.getAddress(this.derivationMode, this.xpub, account, index)];
                    case 2:
                        address = (_a.address = _b.sent(),
                            _a.account = account,
                            _a.index = index,
                            _a);
                        return [2 /*return*/, address];
                }
            });
        });
    };
    Xpub.prototype.buildTx = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var outputs, amount, opReturnData, destAddress, changeAddress, utxoPickingStrategy, feePerByte, sequence, desiredOutputLeftToFit, opReturnOutput, _a, total, unspentUtxoSelected, fee, needChangeoutput, txHexs, txs, inputs, associatedDerivations, txSize, dustLimit, outputsValue;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        outputs = [];
                        amount = params.amount, opReturnData = params.opReturnData, destAddress = params.destAddress, changeAddress = params.changeAddress, utxoPickingStrategy = params.utxoPickingStrategy, feePerByte = params.feePerByte, sequence = params.sequence;
                        desiredOutputLeftToFit = {
                            script: this.crypto.toOutputScript(destAddress),
                            value: amount,
                            address: destAddress,
                            isChange: false
                        };
                        while (desiredOutputLeftToFit.value.gt(this.OUTPUT_VALUE_MAX)) {
                            outputs.push({
                                script: desiredOutputLeftToFit.script,
                                value: new bignumber_js_1["default"](this.OUTPUT_VALUE_MAX),
                                address: destAddress,
                                isChange: false
                            });
                            desiredOutputLeftToFit.value = desiredOutputLeftToFit.value.minus(this.OUTPUT_VALUE_MAX);
                        }
                        if (desiredOutputLeftToFit.value.gt(0)) {
                            outputs.push(desiredOutputLeftToFit);
                        }
                        if (opReturnData) {
                            opReturnOutput = {
                                script: this.crypto.toOpReturnOutputScript(opReturnData),
                                value: new bignumber_js_1["default"](0),
                                address: null,
                                isChange: false
                            };
                            outputs.push(opReturnOutput);
                        }
                        return [4 /*yield*/, utxoPickingStrategy.selectUnspentUtxosToUse(this, outputs, feePerByte)];
                    case 1:
                        _a = _b.sent(), total = _a.totalValue, unspentUtxoSelected = _a.unspentUtxos, fee = _a.fee, needChangeoutput = _a.needChangeoutput;
                        return [4 /*yield*/, Promise.all(unspentUtxoSelected.map(function (unspentUtxo) {
                                return _this.explorer.getTxHex(unspentUtxo.output_hash);
                            }))];
                    case 2:
                        txHexs = _b.sent();
                        return [4 /*yield*/, Promise.all(unspentUtxoSelected.map(function (unspentUtxo) {
                                return _this.storage.getTx(unspentUtxo.address, unspentUtxo.output_hash);
                            }))];
                    case 3:
                        txs = _b.sent();
                        inputs = unspentUtxoSelected.map(function (utxo, index) {
                            return {
                                txHex: txHexs[index],
                                value: utxo.value,
                                address: utxo.address,
                                output_hash: utxo.output_hash,
                                output_index: utxo.output_index,
                                sequence: sequence
                            };
                        });
                        associatedDerivations = unspentUtxoSelected.map(function (_utxo, index) {
                            var _a, _b;
                            if (txs[index] == null) {
                                throw new Error("Invalid index in txs[index]");
                            }
                            return [((_a = txs[index]) === null || _a === void 0 ? void 0 : _a.account) || 0, ((_b = txs[index]) === null || _b === void 0 ? void 0 : _b.index) || 0];
                        });
                        txSize = (0, utils_1.maxTxSizeCeil)(unspentUtxoSelected.length, outputs.map(function (o) { return o.script; }), true, this.crypto, this.derivationMode);
                        dustLimit = (0, utils_1.computeDustAmount)(this.crypto, txSize);
                        // Abandon the change output if change output amount is less than dust amount
                        if (needChangeoutput && total.minus(amount).minus(fee).gt(dustLimit)) {
                            outputs.push({
                                script: this.crypto.toOutputScript(changeAddress.address),
                                value: total.minus(amount).minus(fee),
                                address: changeAddress.address,
                                isChange: true
                            });
                        }
                        outputsValue = outputs.reduce(function (cur, o) { return cur.plus(o.value); }, new bignumber_js_1["default"](0));
                        return [2 /*return*/, {
                                inputs: inputs,
                                associatedDerivations: associatedDerivations,
                                outputs: outputs,
                                fee: total.minus(outputsValue).toNumber(),
                                changeAddress: changeAddress
                            }];
                }
            });
        });
    };
    Xpub.prototype.broadcastTx = function (rawTxHex) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.explorer.broadcast(rawTxHex)];
            });
        });
    };
    // internal
    Xpub.prototype.getAddressesBalance = function (addresses) {
        return __awaiter(this, void 0, void 0, function () {
            var balances;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(addresses.map(function (address) { return _this.getAddressBalance(address); }))];
                    case 1:
                        balances = _a.sent();
                        return [2 /*return*/, balances.reduce(function (total, balance) { return total.plus(balance); }, new bignumber_js_1["default"](0))];
                }
            });
        });
    };
    Xpub.prototype.fetchHydrateAndStoreNewTxs = function (address, account, index) {
        return __awaiter(this, void 0, void 0, function () {
            var pendingTxs, txs, inserted, lastTx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pendingTxs = [];
                        txs = [];
                        inserted = 0;
                        _a.label = 1;
                    case 1:
                        lastTx = this.storage.getLastTx({
                            account: account,
                            index: index,
                            confirmed: true
                        });
                        return [4 /*yield*/, this.explorer.getAddressTxsSinceLastTxBlock(this.txsSyncArraySize, { address: address, account: account, index: index }, lastTx)];
                    case 2:
                        txs = _a.sent();
                        if (pendingTxs.length === 0) {
                            pendingTxs = txs.filter(function (tx) { return !tx.block; });
                        }
                        inserted += this.storage.appendTxs(txs.filter(function (tx) { return tx.block; })); // only insert not pending tx
                        _a.label = 3;
                    case 3:
                        if (txs.length - pendingTxs.length >= this.txsSyncArraySize) return [3 /*break*/, 1];
                        _a.label = 4;
                    case 4:
                        inserted += this.storage.appendTxs(pendingTxs);
                        return [2 /*return*/, inserted];
                }
            });
        });
    };
    Xpub.prototype.checkAddressReorg = function (account, index) {
        return __awaiter(this, void 0, void 0, function () {
            var lastTx, block;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        lastTx = this.storage.getLastTx({
                            account: account,
                            index: index,
                            confirmed: true
                        });
                        if (!lastTx) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.explorer.getBlockByHeight(lastTx.block.height)];
                    case 1:
                        block = _a.sent();
                        // all good the block is valid
                        if (block && block.hash === lastTx.block.hash) {
                            return [2 /*return*/];
                        }
                        // in this case the block is not valid so we delete everything
                        // for that address
                        // TODO: delete only everything for this (address, block)
                        // but need to think if its possible with current storage implem
                        this.storage.removeTxs({
                            account: account,
                            index: index
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return Xpub;
}());
exports["default"] = Xpub;
//# sourceMappingURL=xpub.js.map